import React, { useState } from "react";
import profileIcon from "assets/icon/profile.svg";
import fileIcon from "assets/icon/fileIcon.svg";
import enterIcon from "assets/icon/enterIcon.svg";
import { Col, Input, Row } from "reactstrap";
import moment from "moment";

const Chating = () => {
  const [inputText, setInputText] = useState(
    "Hello, Rich Creating new Patient details"
  );
  const [data, setData] = useState([]);
  const [open, setOpen] = useState();
  const [text, setText] = useState(false);

  const handleChange = (e) => {
    setInputText(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputText !== "") {
      setData([...data, { id: Date.now(), inputText: inputText }]);
    }

    setInputText("");
    setTimeout(() => {
      setText(true);
    }, 2000);
  };

  const handleDelete = (id) => {
    const del = data.filter((item) => item.id !== id);
    setData(del);
  };

  const handleOpen = (id) => {
    setOpen(open === id ? null : id);
  };

  return (
    <>
      <div className="chatContainer">
        <div className="" style={{ marginBottom: "15px" }}></div>
        <div style={{ width: "auto", height: "80vh", overflow: "auto" }}>
          <div
            style={{
              fontSize: "12px",
              fontWeight: 400,
              color: "#9E9E9E",
              marginLeft: "40px",
            }}
          >
            Richard C Fuller 31/11/2024
          </div>
          <div className="d-flex justify-content-start mt-1 gap-2">
            <div className="chatProfileIcon">
              <img src={profileIcon} />
            </div>
            <div className="chatText">Hi Raj, How is your work going on?</div>
          </div>
          <div
          // style={{ flexDirection: "column" }}
          >
            {data.map((name) => (
              <>
                <div className="d-flex mt-3 gap-2  justify-content-end">
                  <div>
                    {/* <div style={{ position: "absolute" }}>
                      {open === name.id && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginRight: "37px",
                            marginBottom: "10px",
                            border: "1px solid #dbcad8",
                            borderRadius: "6px",
                          }}
                        >
                          <button
                            className="btnAlign"
                            onClick={() => handleDelete(name.id)}
                          >
                            Delete
                          </button>
                          <button className="btnAlign">Edit</button>
                        </div>
                      )}
                    </div> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                        marginRight: "40px",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#9E9E9E",
                      }}
                    >
                      29/11/2024
                    </div>
                    <div className="d-flex gap-2 justify-content-end">
                      <div
                        onClick={() => handleOpen(name.id)}
                        className="chatText"
                        style={{
                          border: "1px solid #D3D3D3",
                          backgroundColor: "white",
                          borderRight: "3px solid #702C62",
                          height: "auto",
                          paddingTop: "7px",
                          paddingBottom: "7px",
                        }}
                      >
                        <div
                          style={{
                            width: "330px",
                            wordWrap: "break-word",
                          }}
                        >
                          {name.inputText.length > 40
                            ? "\n" + name.inputText
                            : name.inputText}
                            
                        </div>
                      </div>
                      <div className="chatProfileIcon">
                        <img src={profileIcon} />
                      </div>
                    </div>
                  </div>
                </div>
                {text && (
                  <div className="d-flex mt-3 gap-2">
                    <div className="chatProfileIcon">
                      <img src={profileIcon} />
                    </div>
                    <div className="chatText">Okay, If you are free could you help me with this item order 123456 error? </div>
                  </div>
                )}
              </>
            ))}
          </div>
        </div>
      </div>
      <Row className="replyFooter">
        <Col lg={10}>
          <Input
            type="text"
            placeholder="Enter reply"
            style={{ background: "#F7F7F7" }}
            value={inputText}
            onChange={handleChange}
          />
        </Col>
        <Col lg={1}>
          <img src={fileIcon} />
        </Col>
        <Col lg={1} onClick={handleSubmit}>
          <img src={enterIcon} className="cursor-pointer" />
        </Col>
      </Row>
    </>
  );
};

export default Chating;
